export default "__VITE_ASSET__BIZr3mek__"